import React, { useEffect } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, func, shape } from "prop-types";
import { NotificationsPush } from "@ui-kit/components/index.es";

import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";

import { actions, selectors } from "reducers/pushNotifications";

import * as deviceUtils from "util/device";
import * as i18n from "util/i18n";
import Notification from "../../_components/Notification";
import { isCurrentDeviceRegistered } from "../../../util/pushNotifications";

function ListDevices({ dispatch, isDesktop, isMobileNative, fetching, fetchingAction, devices }) {
    useEffect(() => {
        dispatch(actions.listUserDevicesConfigured(isMobileNative));
    }, []);

    const renderTitleMobile = () => (
        <div>
            <h1 className="m-0 align-center">
                <I18n id="settings.mobile.notificationPush" />
            </h1>
        </div>
    );

    const linkDevice = () => {
        dispatch(actions.pushNotificationsRegisterUserDevice());
    };

    const unlinkDevice = (deviceToDeleteActive) => {
        dispatch(actions.pushNotificationsDeleteUserDevice(deviceToDeleteActive));
    };

    const renderContent = () => {
        const devicesSubtitle = i18n.get("push.notifications.title");
        const headText = i18n.get("push.notifications.list.devices.detail");
        const deleteDeviceText = i18n.get("push.notifications.title.delete");
        const emptyStateText = i18n.get("push.notifications.list.devices.emptyState");

        const devicesList = devices?.map((dispositivo) => ({
            idDevice: dispositivo.deviceId,
        }));

        return (
            <div className="px-3">
                <NotificationsPush
                    devicesArray={devices}
                    devicesSubtitle={devicesSubtitle}
                    loading={fetching}
                    loadingLinkDeviceButton={fetchingAction}
                    headText={headText}
                    showLinkDeviceButton={isMobileNative}
                    deleteDeviceText={deleteDeviceText}
                    handleLink={linkDevice}
                    handleDeleteDevice={unlinkDevice}
                    deviceCurrentId={isMobileNative ? deviceUtils.getDeviceId() : ""}
                    emptyStateText={emptyStateText}
                    disabledLinkDeviceButton={
                        fetchingAction || (isMobileNative && isCurrentDeviceRegistered(devicesList))
                    }
                />
            </div>
        );
    };

    return (
        <>
            <Notification scopeToShow="pushDevices" />
            <div className="admin-detail-head pl-0 pr-1">
                <Head
                    backLinkTo="/settings"
                    centerElement={!isDesktop && renderTitleMobile}
                    centerContentClassName="mx-5"
                    headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                    accessibilityTextId="settings.mobile.notificationPush"
                />
                {isDesktop && (
                    <div className="view-title mb-15">
                        <h1>{i18n.get("settings.mobile.notificationPush")}</h1>
                    </div>
                )}
            </div>
            <MainContainer showLoader={fetching}>{renderContent()}</MainContainer>
        </>
    );
}

ListDevices.propTypes = {
    dispatch: func.isRequired,
    devices: arrayOf(shape({})).isRequired,
    fetching: bool.isRequired,
    fetchingAction: bool.isRequired,
    isMobileNative: bool.isRequired,
    isDesktop: bool.isRequired,
};

const mapStateToProps = (state) => ({
    devices: selectors.configuredDevices(state),
    fetching: selectors.getFetching(state),
    fetchingAction: selectors.getFetchingAction(state),
});

export default connect(mapStateToProps)(ListDevices);
